// @flow
import { connect } from 'react-redux'
import ImportEntitiesPage from './ImportEntitiesPage'
import _ from 'lodash'
import getJson from '../services/getJson'
import postJson from '../services/postJson'
import * as reducer from '../redux/ducks/importEntitiesPage/reducers'
import type { Store } from '../redux/ducks'

const ERRORS_URL = '/api/v1/provider_imported_entities/errors'
const IMPORT_URL = '/api/v1/provider_imported_entities'

const t = {
  done_response:
    'Мы запустили импорт аудиторий и объявлений, данные обновятся в течение нескольких минут'
}

function mapStateToProps(state: Store, ownProps) {
  return {
    ...ownProps,
    ...state.importEntitiesPage
  }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onInit: () => {
      getJson(ERRORS_URL).done((response) => {
        dispatch(reducer.init(response.data))
      })
    },
    onImport: (provider: string) => {
      dispatch(reducer.patch({ isLoading: true }))
      postJson(IMPORT_URL, { data: { provider: provider } })
        .done(() => window.alert(t.done_response))
        .fail(() => window.alert('Internal error'))
        .always(() => dispatch(reducer.patch({ isLoading: false })))
    }
  }
}

const ImportEntitiesPageContainer = connect<Object, Object, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(ImportEntitiesPage)

export default ImportEntitiesPageContainer
